import {MUI} from '@verihubs/pandora';

const {createTheme, colors} = MUI;

export const AppTheme = createTheme({
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: colors.blue[500],
        },
      },
    },
  },
});
